// extracted by mini-css-extract-plugin
export default {"box":"HighlightBox_box__uO7kK"};